import React from "react";
import Dialog from "../../base/dialog";
import CreateProductForm from "../../app-specific/create-product-form";
import {DialogContent, DialogTitle} from "@mui/material";


const AddNewProductDialog = ({open, setOpen, onSuccess}) => {

    return (
        <>
            <Dialog
                open={open}
                setOpen={setOpen}
                className={'new-product-dialog'}
                maxWidth={'sm'}
            >
                <DialogTitle>
                    Add a New Product
                </DialogTitle>
                <DialogContent dividers>
                    <CreateProductForm
                        className={'px-4 mb-3'}
                        onProductCreated={onSuccess}
                        terminate={setOpen}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default AddNewProductDialog;
